import { Component, OnInit } from "@angular/core";
import { DataService } from "./shared/services/data.service";
import { MerchantService } from "./shared/services/merchant.service";
import { ThemeService } from "./core/services/theme.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  title = "webshop";
  mercahnt: {};
  merchantUrl: string = "https://blakesshawn.cicod.com/webshop";
  merchantName: string;
  merchantConfig: any = {};
  merchantAddress: string = "";
  merchantPrimaryColor: string;
  merchantPrimaryColorRgb: string;
  customProperty: any;
  hexColors: any;

  constructor(
    private dataService: DataService,
    private merchantService: MerchantService,
    private themeService: ThemeService,
    private router: Router
  ) {}

  getTenantId() {
    this.merchantUrl = window.location.href;
    // this.merchantUrl = "https://usexport.cicodsaasstaging.com/webshop";

    // this.merchantUrl = "https://sadegunleshop.cicodsaasdev.com/webshop/";
    // this.merchantUrl = "https://fabricsbyrebs.cicodsaasstaging.com/webshop/";
    console.log("Now deployed again currency");

    this.merchantUrl = this.merchantUrl
      .replace(/^(?:https?:\/\/)?(?:www\.)?/i, "")
      .split("/")[0];
    this.merchantName = this.merchantUrl.split(".")[0];
    this.dataService.setMerchant(this.merchantName);
  }

  getMerchant() {
    this.merchantService.getData().subscribe((data) => {
      let msg: string = data.message;
      console.log(msg);

      if (msg.includes("EXPIRED")) {
        console.log("expired" + msg);
        this.router.navigate([`not-found`], {
          queryParams: {
            erroType: "expired",
          },
        });
      }

      this.dataService.setMerchantDetails(data.data);
    });
  }

  hexToRgb(hex, opacity) {
    hex = hex.replace("#", "");
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    let result = "rgba(" + r + "," + g + "," + b + "," + opacity / 100 + ")";
    return result;
  }

  setTheme() {
    this.merchantPrimaryColorRgb = this.hexToRgb(this.merchantPrimaryColor, 10);
    this.customProperty = {
      "--primary-color": this.merchantPrimaryColor,
      "--primary-color-light": this.merchantPrimaryColorRgb,
    };

    this.themeService.setCustomTheme(this.customProperty);
  }

  getMerchantConfig() {
    this.merchantService.getConfig().subscribe(
      (data) => {
        if (data.message === "Could not get merchant db login") {
          this.router.navigate(["not-found"]);
        }
        this.merchantConfig = data.data;
        // console.log(this.merchantConfig);

        this.merchantPrimaryColor = this.merchantConfig.theme_primary_color;
        this.dataService.setMerchantConfig(data.data);
        this.setTheme();
      },
      (err) => {
        console.log(err);
      }
    );
  }

  async ngOnInit() {
    this.getMerchantConfig();
    this.getTenantId();
    this.getMerchant();
  }
}
